// @flow
import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { Toggle, Flex } from '../'
import { ControllerError } from './'

type ToggleControllerProps = {
  name: string,
  label: string,
  style?: { [key: string]: string | number },
  isDisabled?: boolean,
  isBordered?: boolean,
  [key: string]: any
}

const ToggleController = ({ name, label, style, isDisabled, isBordered, ...props }: ToggleControllerProps) => {
  const { errors } = useFormContext()
  return (
    <Flex column>
      <Controller
        name={name}
        render={({ field: { value, onChange } }) => (
          <Toggle
            checked={value}
            id={`${name}-toggle`}
            isBordered={isBordered}
            isDisabled={isDisabled}
            label={label}
            style={style}
            onChange={e => onChange(e.currentTarget.checked)}
          />
        )}
        {...props}
      />
      <ControllerError errors={errors} name={name} />
    </Flex>
  )
}

export { ToggleController }
